import { useState, useImperativeHandle, forwardRef, useEffect } from "react"
import { Box, Button, Grid, Typography, CircularProgress, Checkbox, FormControlLabel } from "@mui/material"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import LoadingButton from "@mui/lab/LoadingButton"
import BuscarIcon from "../../../assets/iconos/Buscar.ico"

import CustomFieldsetAccordion from "../../../components/CustomFieldsetAccordion"
import AsyncDebounceMultiSelect from "../../../components/CustomAsyncDebounceMultiSelect"
import InputNestedChildren from "../../../components/CustomInputNestedChildren"
import CustomTextField from "../../../components/CustomTextField"

import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"

const StyledButtonContainerFiltro = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
}))

const ContainerFiltrosGeneralesFA = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto auto auto",
  gridTemplateAreas: `
          "IProducto IProducto IProducto IProducto IProducto IProducto IPresentacion IPresentacion IPresentacion IPresentacion IPresentacion IPresentacion"
          "IMedida IMedida IMedida IMedida IMedida IMedida IMarca IMarca IMarca IMarca IMarca IMarca"
          "ILinea ILinea ILinea ILinea ILinea ILinea IIMR IIMR IIMR IIMR IIMR IIMR"
          "IParams IParams IParams IParams IParams IParams IParams IParams IParams IParams IParams IParams"
          "IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar"
        `,
  gap: "8px",
  rowGap: "12px",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto auto auto auto auto auto auto",
    gridTemplateAreas: `
      "IProducto"
      "IPresentacion"
      "IMedida"
      "IMarca"
      "ILinea"
      "IIMR"
      "IParams"
      "IBtnFiltrar"
    `,
  },
}))
const IProducto = styled(Box)({
  gridArea: "IProducto",
})
const IPresentacion = styled(Box)({
  gridArea: "IPresentacion",
})
const IMedida = styled(Box)({
  gridArea: "IMedida",
})
const IMarca = styled(Box)({
  gridArea: "IMarca",
})
const ILinea = styled(Box)({
  gridArea: "ILinea",
})
const IIMR = styled(Box)({
  gridArea: "IIMR",
})
const IParams = styled(Box)({
  gridArea: "IParams",
})
const IBtnFiltrar = styled(Box)({
  gridArea: "IBtnFiltrar",
})
const AccordionFiltros = forwardRef(({ onFilteredProducts, apiFILTROS, page, limit }, ref) => {
  const [isExpandedFiltrosGeneralesFA, setIsExpandedFiltrosGeneralesFA] = useState(true)
  const handleToggleFiltrosGeneralesFA = () => {
    setIsExpandedFiltrosGeneralesFA(!isExpandedFiltrosGeneralesFA)
  }

  const [isLoading, setIsLoading] = useState(false) // Loading cuando se da click en btn FILTRAR

  const [filtrosGenerales, setFiltrosGenerales] = useState({
    articulos: [],
    presentaciones: [],
    medidas: [],
    marcas: [],
    lineas: [],
    imr: "",
  })
  const handleSetFiltrosGenerales = (k, v) => setFiltrosGenerales((prev) => ({ ...prev, [k]: v }))
  const [productosConCantidad, setProductosConCantidad] = useState(false)

  useImperativeHandle(ref, () => ({
    handleFiltros: (page) => {
      filtros(page)
    },
  }))
  // Función para cargar los datos de los productos desde API
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 600) {
        setIsExpandedFiltrosGeneralesFA(false)
      } else {
        setIsExpandedFiltrosGeneralesFA(true)
      }
    }

    // window.addEventListener('resize', handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", handleResize)
    }
    // cargarProductos();
  }, [page])
  // Función que realiza la búsqueda de productos por filtro
  const getCodesFiltros = (arr, key) => {
    if (arr && arr.length > 0) {
      return arr.map((i) => i?.[key]?.trim())
    }
    return []
  }
  const filtros = async (newPage) => {
    if (newPage < 0) newPage = 1
    setIsLoading(true)
    // if page or newPage is 0, then set page to 1
    try {
      const request = {
        codigo: {
          codigoDescripcion: getCodesFiltros(filtrosGenerales.articulos, "artcodigo"),
          presentacion: getCodesFiltros(filtrosGenerales.presentaciones, "precodigo"),
          marca: getCodesFiltros(filtrosGenerales.marcas, "marcodigo"),
          medida: getCodesFiltros(filtrosGenerales.medidas, "medcodigo"),
          linea: getCodesFiltros(filtrosGenerales.lineas, "lincodigo"),
          pIngresoEgreso: filtrosGenerales.imr,
          pShow: productosConCantidad,
        },
        limit,
        page: newPage + 1,
      }

      const options = {
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
      let response = await fetchwrapper(apiFILTROS, options)
      response = await response.json()
      // map to add a seleccionados property
      // setProductos(response);
      onFilteredProducts(response)
      setIsLoading(false)
    } catch (err) {
      alert("Error: No se pudo completar la solicitud de filtros. Intente de nuevo")
      console.error(err)
      setIsLoading(false)
    }
  }

  return (
    <div>
      <CustomBackdrop isLoading={isLoading} />
      <CustomFieldsetAccordion
        title="Filtros Generales"
        expanded={isExpandedFiltrosGeneralesFA}
        onToggle={handleToggleFiltrosGeneralesFA}
      >
        <ContainerFiltrosGeneralesFA>
          <IProducto>
            <AsyncDebounceMultiSelect
              label="Articulos"
              endpoint="/filter/getAny"
              endpointJson={{ label: "articulo" }}
              queryKeyModal="filterArticles"
              optionKey={(option) => option.artcodigo || option.id || option.label || ""}
              selectedOptions={filtrosGenerales.articulos}
              setSelectedOptions={(v) => handleSetFiltrosGenerales("articulos", v)}
              debounceTime={600}
              placeholder="Buscar por código o descripción"
              formatOptionLabel={(item) => {
                if (item.isCustom) {
                  return item.artcodigo || item.label || String(item)
                }
                return `${(item.artcodigo || "").trim()} - ${(item.artdescri || "").trim()}`
              }}
              noOptionsText="No se encontraron artículos"
              freeSolo={true}
              createCustomOption={(inputValue) => ({
                artcodigo: inputValue,
                artdescri: inputValue,
                isCustom: true,
              })}
            />
          </IProducto>
          <IPresentacion>
            <AsyncDebounceMultiSelect
              label="Presentacion"
              endpoint="/filter/getAny"
              endpointJson={{ label: "presentacion" }}
              queryKeyModal="filterPresentacion"
              optionKey={(option) => `${option.precodigo}`}
              selectedOptions={filtrosGenerales.presentaciones}
              setSelectedOptions={(v) => handleSetFiltrosGenerales("presentaciones", v)}
              debounceTime={600}
              placeholder="Buscar por código o descripción"
              formatOptionLabel={(item) => {
                if (item.isCustom) {
                  return item.precodigo || item.label || String(item)
                }
                return `${item.precodigo?.trim() || ""} - ${item.predescri?.trim() || ""}`
              }}
              noOptionsText="No se encontraron presentaciones"
              freeSolo={true}
              createCustomOption={(inputValue) => ({
                precodigo: inputValue,
                predescri: `Presentación personalizada: ${inputValue}`,
                isCustom: true,
              })}
            />
          </IPresentacion>

          <IMedida>
            <AsyncDebounceMultiSelect
              label="Medida"
              endpoint="/filter/getAny"
              endpointJson={{ label: "medida" }}
              queryKeyModal="filterMedida"
              optionKey={(option) => `${option.medcodigo}`}
              selectedOptions={filtrosGenerales.medidas}
              setSelectedOptions={(v) => handleSetFiltrosGenerales("medidas", v)}
              debounceTime={600}
              placeholder="Buscar por código o descripción"
              formatOptionLabel={(item) => {
                if (item.isCustom) {
                  return item.medcodigo || item.label || String(item)
                }
                return `${item.medcodigo?.trim() || ""} - ${item.meddescri?.trim() || ""}`
              }}
              noOptionsText="No se encontraron medidas"
              freeSolo={true}
              createCustomOption={(inputValue) => ({
                medcodigo: inputValue,
                meddescri: `Medida personalizada: ${inputValue}`,
                isCustom: true,
              })}
            />
          </IMedida>

          <IMarca>
            <AsyncDebounceMultiSelect
              label="Marca"
              endpoint="/filter/getAny"
              endpointJson={{ label: "marca" }}
              queryKeyModal="filterMarca"
              optionKey={(option) => `${option.marcodigo}`}
              selectedOptions={filtrosGenerales.marcas}
              setSelectedOptions={(v) => handleSetFiltrosGenerales("marcas", v)}
              debounceTime={600}
              placeholder="Buscar por código o descripción"
              formatOptionLabel={(item) => {
                if (item.isCustom) {
                  return item.marcodigo || item.label || String(item)
                }
                return `${item.marcodigo?.trim() || ""} - ${item.mardescri?.trim() || ""}`
              }}
              noOptionsText="No se encontraron Marca"
              freeSolo={true}
              createCustomOption={(inputValue) => ({
                marcodigo: inputValue,
                mardescri: `Marca personalizada: ${inputValue}`,
                isCustom: true,
              })}
            />
          </IMarca>
          <ILinea>
            <InputNestedChildren
              endpoint="/linea/get_lineas"
              label="Línea"
              placeholder="Filtrar por línea"
              value={filtrosGenerales.lineas}
              onChange={(v) => handleSetFiltrosGenerales("lineas", v)}
              fetchResponse={{
                code: "lincodigo",
                description: "lindescri",
              }}
              noOptionsText="No se encontraron líneas"
            />
          </ILinea>
          <IIMR>
            <CustomTextField
              label="IMR/EMR"
              value={filtrosGenerales.imr}
              setValue={(v) => handleSetFiltrosGenerales("imr", v)}
            />
          </IIMR>
        </ContainerFiltrosGeneralesFA>

        <IParams>
          <FormControlLabel
            control={
              <Checkbox
                checked={productosConCantidad}
                onChange={() => setProductosConCantidad(!productosConCantidad)}
                color="primary"
              />
            }
            label="Productos Con Cantidad"
          />
        </IParams>

        <IBtnFiltrar>
          <div className={StyledButtonContainerFiltro}>
            <LoadingButton
              variant="contained"
              endIcon={<img src={BuscarIcon} style={{ width: "22px" }} alt="buscar" />}
              onClick={() => filtros(0)}
              color="secondary"
              loading={isLoading}
              style={{ marginRight: "16px" }}
            >
              Filtrar
            </LoadingButton>
          </div>
        </IBtnFiltrar>
      </CustomFieldsetAccordion>
    </div>
  )
})

export default AccordionFiltros
